import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onMounted, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollToTop',
  setup(__props) {

const showScrollToTop = ref(false);

function handleScroll() {
  showScrollToTop.value = window.scrollY > 200; // Show button after scrolling 200px
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  return (showScrollToTop.value)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "scroll-to-top",
        onClick: scrollToTop
      }, " ↑ " + _toDisplayString(_ctx.$t('navigation.top-scroll')), 1))
    : _createCommentVNode("", true)
}
}

})